module.exports = __webpack_public_path__ + "static/img/weikang.d39fa3ed.png";